import React from 'react';
import {
  Sparkles,
  ShieldCheck,
  GitPullRequest,
  GitBranch,
  MessageSquare,
  BarChart3,
  Users,
  Settings,
} from 'lucide-react';

/**
 * 8 core capabilities as specified in FR-007
 * References: specs/010-onboarding-path/spec.md FR-007
 */
const CAPABILITIES = [
  {
    title: 'AI-Powered Code Reviews',
    description: 'Automated code analysis with intelligent suggestions.',
    icon: Sparkles,
  },
  {
    title: 'Security Vulnerability Detection',
    description: 'Identify and prevent security issues before deployment.',
    icon: ShieldCheck,
  },
  {
    title: 'Pull Request Insights',
    description: 'Comprehensive PR analysis and quality metrics.',
    icon: GitPullRequest,
  },
  {
    title: 'Multi-Repo Support',
    description: 'Manage and monitor multiple repositories seamlessly.',
    icon: GitBranch,
  },
  {
    title: 'Automated Comments',
    description: 'Intelligent feedback directly in your pull requests.',
    icon: MessageSquare,
  },
  {
    title: 'Performance Analysis',
    description: 'Track and optimize code performance metrics.',
    icon: BarChart3,
  },
  {
    title: 'Team Collaboration Tools',
    description: 'Enhanced team workflows and knowledge sharing.',
    icon: Users,
  },
  {
    title: 'Custom Review Rules',
    description: 'Configure organization-specific code standards.',
    icon: Settings,
  },
];

export const CapabilityGrid: React.FC = () => {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-3">
      {CAPABILITIES.map((capability) => {
        const Icon = capability.icon;
        return (
          <div
            key={capability.title}
            className="flex flex-col gap-1.5 rounded-lg border border-border/80 bg-card p-3 text-left shadow-sm"
          >
            <Icon className="h-4 w-4 shrink-0 text-primary" />
            <span className="text-sm font-semibold leading-tight">{capability.title}</span>
            <p className="text-xs leading-snug text-muted-foreground">{capability.description}</p>
          </div>
        );
      })}
    </div>
  );
};
